export default __webpack_public_path__ + "static/media/icon-back-dark.1982e044.svg";